import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

import { ref } from 'vue';
const _withScopeId = n => (_pushScopeId("data-v-9d93121c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "59px"
  }
}, null, -1));
const _hoisted_2 = {
  class: "tabbar"
};
const _hoisted_3 = {
  class: "icon"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "selectIcon"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "name"
};
export default {
  __name: 'tabbar',
  setup(__props) {
    const tabbar = ref([{
      icon: require('@/assets/image/pages.png'),
      name: '首页',
      selectIcon: require('@/assets/image/page.png'),
      path: '/index'
    }, {
      icon: require('@/assets/image/faxians.png'),
      name: '发现',
      selectIcon: require('@/assets/image/faxian.png'),
      path: '/find'
    }, {
      icon: require('@/assets/image/jin.png'),
      name: '聊天室',
      selectIcon: require('@/assets/image/jin.png'),
      path: '/competition'
    }, {
      icon: require('@/assets/image/pintais.png'),
      name: '平台',
      selectIcon: require('@/assets/image/pintai.png'),
      path: '/platform'
    }, {
      icon: require('@/assets/image/wodes.png'),
      name: '我的',
      selectIcon: require('@/assets/image/wode.png'),
      path: '/me'
    }]);
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabbar), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: index
        }, [_createVNode(_component_router_link, {
          "active-class": "activeIndex",
          to: item.path
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: item.icon,
            alt: ""
          }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
            src: item.selectIcon,
            alt: ""
          }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["to"])]);
      }), 128))])])], 64);
    };
  }
};